import { X } from "lucide-react";

import { Input } from "../ui/input";

// Os dois campos da lista (filtro de contato e busca nas mensagens) têm o
// mesmo desenho e as mesmas regras: Esc ou o X limpam, e com 1 caractere só o
// aviso do mínimo — a busca começa em 2.
const CampoDeBusca = ({
  icone: Icone,
  valor,
  aoMudar,
  placeholder,
  // Texto inteiro para leitor de tela e dica, quando o placeholder é curto.
  rotulo = placeholder,
  rotuloLimpar = "Limpar",
  inputRef,
  autoFocus,
  ...resto
}) => (
  <div className="relative min-w-0 flex-1">
    <Icone className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    <Input
      {...resto}
      ref={inputRef}
      autoFocus={autoFocus}
      placeholder={placeholder}
      aria-label={rotulo}
      title={rotulo}
      type="text"
      value={valor}
      onChange={(e) => aoMudar(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Escape" && valor) {
          e.preventDefault();
          aoMudar("");
        }
      }}
      className="h-9 rounded-full pl-9 pr-8"
    />
    {valor && (
      <button
        type="button"
        aria-label={rotuloLimpar}
        title={`${rotuloLimpar} (Esc)`}
        onClick={(e) => {
          aoMudar("");
          e.currentTarget.parentElement.querySelector("input")?.focus();
        }}
        className="absolute right-2 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    )}
    {valor.trim().length === 1 && (
      <span className="pointer-events-none absolute right-8 top-1/2 -translate-y-1/2 text-[10px] text-muted-foreground">
        mín. 2 letras
      </span>
    )}
  </div>
);

export default CampoDeBusca;
